import React, { useState, useEffect } from 'react';

let showToastFunction = null;

export const showToast = (message, isInfo = false) => {
  if (showToastFunction) {
    showToastFunction(message, isInfo);
  }
};

function Toast() {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [isInfo, setIsInfo] = useState(false);

  useEffect(() => {
    showToastFunction = (msg, info) => {
      setMessage(msg);
      setIsInfo(info);
      setVisible(true);
      
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };

    return () => {
      showToastFunction = null;
    };
  }, []);

  return (
    <div
      className={`fixed bottom-5 right-5 z-50 transform transition-all duration-300 bg-brand-800 text-white px-6 py-3 rounded-xl shadow-xl flex items-center space-x-3 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      <span className="text-brand-300">
        {isInfo ? (
          <i className="fas fa-info-circle text-amber-400"></i>
        ) : (
          <i className="fas fa-check-circle text-emerald-400"></i>
        )}
      </span>
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
}

export default Toast;
